import { ReactComponent as Zoom } from 'icons//zoom.svg';
import { ReactComponent as GoogleMeet } from 'icons/google_meet.svg';
import { ReactComponent as MicrosoftTeams } from 'icons/microsoft_teams.svg';
import { ReactComponent as GoogleCalendar } from 'icons/google_calendar.svg';
import { ReactComponent as MicrosoftOutlook } from 'icons/microsoft_outlook.svg';
import { ReactComponent as GoogleDrive } from 'icons/google_drive.svg';
import { ReactComponent as Google } from 'icons/google.svg';
import { ReactComponent as Gmail } from 'icons/gmail.svg';
import { ReactComponent as Slack } from 'icons/slack.svg';
import { ReactComponent as Microsoft} from 'icons/microsoft.svg';

import { SvgIcon } from '@mui/material';

export const third_party_constants = {
    microsoft: {
        name: "Microsoft",
        color: "microsoft",
        icon: (props) => (<SvgIcon {...props}><Microsoft/></SvgIcon>),
    },
    zoom: {
        name: "Zoom",
        color: "zoom",
        icon: (props) => (<SvgIcon {...props}><Zoom/></SvgIcon>),
    },
    google_meet: {
        name: "Google Meet",
        color: "google_meet",
        icon: (props) => (<SvgIcon {...props}><GoogleMeet/></SvgIcon>),
    },
    microsoft_teams: {
        name: "Teams",
        color: "microsoft_teams",
        icon: (props) => (<SvgIcon {...props}><MicrosoftTeams/></SvgIcon>),
    },
    google_calendar: {
        name: "Google Calendar",
        color: "google_calendar",
        icon: (props) => (<SvgIcon {...props}><GoogleCalendar/></SvgIcon>),
    },
    microsoft_outlook: {
        name: "Microsoft Outlook",
        color: "microsoft_outlook",
        icon: (props) => (<SvgIcon {...props}><MicrosoftOutlook/></SvgIcon>),
    },
    google_drive: {
        name: "Google Drive",
        color: "google_drive",
        icon: (props) => (<SvgIcon {...props}><GoogleDrive/></SvgIcon>),
    },
    google: {
        name: "Google",
        color: "google",
        icon: (props) => (<SvgIcon {...props}><Google/></SvgIcon>),
    },
    gmail: {
        name: "Gmail",
        color: "gmail",
        icon: (props) => (<SvgIcon {...props}><Gmail/></SvgIcon>),
    },
    slack: {
        name: "Slack",
        color: "slack",
        icon: (props) => (<SvgIcon {...props}><Slack/></SvgIcon>),
    },
    in_person: (location) => ({
        name: location || "In Person",
    }),
    microsoft: {
        name: "Microsoft",
        color: "microsoft",
        icon: (props) => (<SvgIcon {...props}><Microsoft/></SvgIcon>),
    }
};

